import styled from 'styled-components';

export const OneFour = styled.span`
  display: flex;
  width: 25%;
  padding: 12px;
  flex-direction: column;
`;
